
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import baseURL from "../../config";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Chip,
  IconButton,
  Modal,
  Box,
  Button,
  Grid,
  TextField,
  TablePagination,
  CircularProgress, // ✅ NEW
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import Navbar from "../../Navbar/Navbar";
import ExpiryDate from "../../utils/ExpiryDate.jsx";

const AssignedVessels = () => {
  const { id: crewingAgentId } = useParams();
  const [vesselData, setVesselData] = useState(null);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true); // ✅ NEW

  // Pagination states
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const fetchVesselsForAgent = async () => {
      if (!crewingAgentId) return;
      const token = localStorage.getItem("token");
      setIsLoading(true); // ✅ NEW
      try {
        const response = await axios.get(`${baseURL}/api/getvesselAgent/${crewingAgentId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setVesselData(response.data.vesselAgent);
      } catch (error) {
        console.error("Error fetching vessels:", error);
      } finally {
        setIsLoading(false); // ✅ NEW
      }
    };

    fetchVesselsForAgent();
  }, [crewingAgentId]);

  const filteredShips = vesselData?.vesselIds?.filter(ship =>
    ship?.vesselname?.toLowerCase()?.includes(searchTerm.toLowerCase()) ||
    (ship?.IMO_Number ? String(ship.IMO_Number).toLowerCase().includes(searchTerm.toLowerCase()) : false)
  );

  const currentPageData = filteredShips ?
    filteredShips.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) :
    [];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenModal = (ship) => {
    if (ship) {
      const documents = Object.entries(ship)
        .filter(([key, value]) =>
          ["pipolicydocument", "maritimelabourconvention", "fsdocument", "dmlcp1", "dmlc2"].includes(key) &&
          value
        )
        .map(([key, value]) => {
          let filePath = typeof value === "string" ? value : value?.filePath;

          if (!filePath) return null;

          if (!filePath.startsWith("http")) {
            filePath = `${baseURL}/${filePath.replace(/\\/g, "/")}`;
          }

          return {
            fileName: key,
            filePath: filePath,
          };
        })
        .filter(Boolean);

      setSelectedDocuments(documents);
      setOpenModal(true);
    }
  };

  return (
    <>
      {/* <Navbar /> */}
      {console.log("vesselData", vesselData)}
      <div style={{ padding: "20px" }}>
        {/* <Typography variant="h5" sx={{ mt: 3, mb: 2 }}>
                    Vessels for Agent: {vesselData?.CrewingAgentName || ""}
                </Typography> */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
          <TextField
            label="Search by Vessel Name or IMO Number"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ maxWidth: 300, backgroundColor: "#f5f5f5" }}
          />
          <Typography variant="body2" color="textSecondary">
            {isLoading ? (
              <CircularProgress size={16} />
            ) : (
              `Total vessels: ${filteredShips?.length ?? 0}`
            )}
          </Typography>

        </Box>

        <TableContainer component={Paper} sx={{ maxWidth: "95%", margin: "auto", overflowX: "auto" }}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#C30B12" }}>
                <TableCell sx={{ fontWeight: "bold", color: "white" }}>Sr. No.</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "white" }}>Ship Information</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "white" }}>Insurance Details</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "white" }}>Certificates</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "white" }}>Documents</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 5 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : currentPageData && currentPageData.length > 0 ? (
                currentPageData.map((vessel, index) => (
                  <TableRow key={vessel._id}>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>
                      <Grid container direction="column">
                        <Chip label={`Vessel Name: ${vessel.vesselname}`} sx={{ backgroundColor: "#4caf50", color: "white", fontWeight: "bold" }} />
                        <Typography><b>IMO Number:</b> {vessel.IMO_Number}</Typography>
                        <Typography><b>Ship Type:</b> {vessel.vesseltype}</Typography>
                        <Typography><b>Ship Flag:</b> {vessel.Flag}</Typography>
                        <Typography><b>Gross Tonage: </b>{vessel.gross_tonage}</Typography>
                        <Typography><b>kiloWatt: </b>{vessel.kiloWatt || "-"}</Typography>
                        <Typography><b>BHP: </b>{vessel.bhp || "-"}</Typography>
                      </Grid>
                    </TableCell>
                    <TableCell>
                      <Typography><b>PI Number:</b> {vessel.pipolicynumber}</Typography>
                      <ExpiryDate label="policy date validity" date={vessel.policydateofv} />
                    </TableCell>
                    <TableCell>
                      <Typography><b>MLC Cert No.:</b> {vessel.mlcCert || "N/A"}</Typography>
                      <ExpiryDate label="MLC Exp. Date" date={vessel.mlcExpiryDate} />
                      <ExpiryDate label="Financial Security Validity" date={vessel.fsdvalidity} />
                    </TableCell>
                    <TableCell>
                      <IconButton onClick={() => handleOpenModal(vessel)}>
                        <PictureAsPdfIcon sx={{ color: "red" }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                    {searchTerm ? "No matching vessels found" : "No vessels available"}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          <TablePagination
            component="div"
            count={filteredShips ? filteredShips.length : 0}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
            sx={{ borderTop: "1px solid rgba(224, 224, 224, 1)" }}
          />
        </TableContainer>

        <Modal open={openModal} onClose={() => setOpenModal(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: "60%", md: "50%" },
              maxHeight: "80vh",
              bgcolor: "white",
              boxShadow: 24,
              p: 3,
              borderRadius: 2,
              overflowY: "auto",
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{ textAlign: "center", mb: 2, fontWeight: "bold" }}
            >
              Vessel Documents
            </Typography>
            {selectedDocuments.length > 0 ? (
              selectedDocuments.map((doc, index) => {
                let filePath = doc.filePath.trim();
                if (filePath.startsWith("http://localhost:8000/https")) {
                  filePath = filePath.replace("http://localhost:8000/", "");
                }
                let downloadURL = filePath.startsWith("http") ? filePath : `${baseURL}/${filePath.replace(/\\/g, "/")}`;

                return (
                  <Paper
                    key={doc.fileName || index}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      p: 2,
                      mb: 2,
                      boxShadow: 2,
                      borderRadius: 2,
                      transition: "0.3s",
                      "&:hover": { boxShadow: 4, bgcolor: "#f5f5f5" },
                    }}
                  >
                    <Box display="flex" alignItems="center">
                      <PictureAsPdfIcon sx={{ color: "red", mr: 1 }} />
                      <Typography variant="body1">
                        {doc.fileName ? doc.fileName : "Unknown Document"}
                      </Typography>
                    </Box>
                    {downloadURL ? (
                      <Button
                        variant="contained"
                        href={downloadURL}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Download
                      </Button>
                    ) : (
                      <Typography variant="body2" color="textSecondary">
                        No File Available
                      </Typography>
                    )}
                  </Paper>
                );
              })
            ) : (
              <Typography align="center" color="textSecondary">
                No documents available
              </Typography>
            )}
            <Box display="flex" justifyContent="center" mt={2}>
              <Button variant="contained" color="error" onClick={() => setOpenModal(false)}>
                Close
              </Button>
            </Box>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default AssignedVessels;
